module.exports = __webpack_public_path__ + "static/img/b1_footer.a1316e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/core/b1_footer.png
// module id = Pyam
// module chunks = 1